import { render, staticRenderFns } from "./short-profile.vue?vue&type=template&id=7c66e7a8&scoped=true&"
import script from "./short-profile.vue?vue&type=script&lang=js&"
export * from "./short-profile.vue?vue&type=script&lang=js&"
import style0 from "./short-profile.vue?vue&type=style&index=0&id=7c66e7a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c66e7a8",
  null
  
)

export default component.exports